(function(){
  const heroes = document.querySelectorAll('[data-ics-hero]');
  if (!heroes.length) return;

  const markReady = (el) => el.classList.add('is-ready');

  const hasIO = 'IntersectionObserver' in window;

  heroes.forEach((hero) => {
    if (!hasIO) {
      requestAnimationFrame(() => markReady(hero));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          markReady(hero);
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.2 });

    io.observe(hero);
  });
})();
